import _ from "lodash";
import type {
    IChartData,
    TrafficShareBarChartApiRecord,
} from "app/pages/industry-analysis/traffic-sources/MarketingChannels/TrafficShareBarChart/TrafficShareBarChart.types";
import { CHART_COLORS } from "app/constants/ChartColors";
import { trafficSourcesForSegments } from "app/Shared/utils";
import type { IServices } from "../../common/useMarketingChannelsServices";

export const adaptApiData = (data: TrafficShareBarChartApiRecord, services: IServices): IChartData => {
    if (!data) {return null;}

    const channelNames = Object.keys(data);
    const channelValues = Object.values(data);
    const totalValue = _.sum(channelValues);

    const dataRecords = channelNames.map((channelName) => {
        const trafficSource = trafficSourcesForSegments[channelName] ?? {};
        const { title, priority, tooltipKey } = trafficSource;
        const channelValue = data[channelName];
        const percentage = channelValue / totalValue;
        const color = CHART_COLORS.trafficSourcesColorsBySourceMMX[channelName];

        return {
            key: services.translate(title),
            color: color,
            y: percentage,
            priority: priority,
            tooltipKey,
        };
    });

    return {
        name: "chartData",
        data: dataRecords,
    };
};

export const sortChartData = (data: IChartData) => {
    const sortedRecords = _.sortBy(data.data, (x) => x.priority);
    return {
        name: data.name,
        data: sortedRecords,
    };
};
